// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#search-class-filter[data-v-570ee322]  .vs__dropdown-toggle{border:none;padding:auto 0}#search-class-filter[data-v-570ee322]  .vs__open-indicator{display:none}", ""]);
// Exports
module.exports = exports;
